import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearCart } from "../../Redux/Slices/cartSlice";

export default function CheckoutPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cartItems = useSelector((state) => state.cart.items);

  const [formData, setFormData] = useState({
    name: "",
    surname: "",
    email: "",
    phone: "",
    city: "",
    address: "",
    postalCode: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const { name, surname, email, phone, city, address, postalCode } = formData;
    const errors = [];

    if (!name.trim() || name.trim().length < 2)
      errors.push("Ім'я має містити щонайменше 2 символи");

    if (!surname.trim() || surname.trim().length < 2)
      errors.push("Прізвище має містити щонайменше 2 символи");

    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      errors.push("Введіть коректний e-mail (наприклад: user@gmail.com)");

    if (!phone.trim() || !/^\+?[\d\s\-()]{10,15}$/.test(phone))
      errors.push(
        "Введіть коректний номер телефону (наприклад: +380501234567)",
      );

    if (!city.trim() || city.trim().length < 2)
      errors.push("Введіть назву міста");

    if (!address.trim() || address.trim().length < 5)
      errors.push("Введіть повну адресу доставки");

    if (!postalCode.trim() || !/^\d{5}$/.test(postalCode))
      errors.push("Поштовий індекс має містити 5 цифр (наприклад: 43000)");

    if (errors.length > 0) {
      alert(errors.join("\n"));
      return;
    }

    dispatch(clearCart());
    alert("Замовлення оформлено! Дякуємо за покупку!");
    navigate("/");
  };

  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);
  const totalAmount = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0,
  );

  return (
    <div className="checkout-container">
      <div className="checkout-header">
        <h1>Оформити замовлення</h1>
      </div>

      <div className="checkout-content">
        {/* Cart Items Table */}
        <div className="cart-items-table">
          <div className="table-header">
            <span className="column product">Товар</span>
            <span className="column quantity">Кількість</span>
            <span className="column price">Ціна</span>
            <span className="column total">Сума</span>
          </div>

          {cartItems.length === 0 ? (
            <p style={{ padding: "16px" }}>Кошик порожній</p>
          ) : (
            cartItems.map((item) => (
              <div key={item.id} className="table-row">
                <span className="column product">{item.title}</span>
                <span className="column quantity">{item.quantity} шт.</span>
                <span className="column price">{item.price} грн</span>
                <span className="column total">
                  {item.price * item.quantity} грн
                </span>
              </div>
            ))
          )}

          <div className="table-footer">
            <div className="total-row">
              <span>Усього товарів:</span>
              <span>{totalItems} шт.</span>
            </div>
            <div className="total-row">
              <span>Сума замовлення:</span>
              <span className="total-amount">{totalAmount} грн</span>
            </div>
          </div>
        </div>

        {/* Delivery Details */}
        <div className="delivery-details">
          <h2>Деталі доставки</h2>
          <p className="required-fields">* Всі поля мають бути заповнені</p>

          <div className="delivery-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Ім'я*</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="city">Місто*</label>
                <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="surname">Прізвище*</label>
                <input
                  type="text"
                  id="surname"
                  name="surname"
                  value={formData.surname}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="address">Адреса*</label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="email">E-mail*</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="form-group">
                <label htmlFor="postalCode">Поштовий індекс*</label>
                <input
                  type="text"
                  id="postalCode"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Телефон*</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="form-actions">
              <Link to="/cart">
                <button className="back-button">Повернутись назад</button>
              </Link>
              <button className="order-button" onClick={handleSubmit}>
                Замовити!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
